export enum FLAGS_ENUM {
  HAS_BUILDER = "has_builder",
  HAS_FEATURE_TEMPLATE = "has_feature_template",
  HIDE_MERCH = "hide_merch",
  HIDE_REPORT = "hide_report",
  HIDE_CATALOG = "hide_catalog",
  HAS_SKU_REPORT = "has_sku_report",
  HAS_EMOTION_AI = "has_emotion_ai",
  HAS_ABTEST = "has_abtest",
  HAS_MERCHANDISING_REPORT = "has_merchandising_report",
  HAS_MERCH_DEPLOYMENT = "has_merch_deployment",
  HAS_FEATURE_FORMULAS_AI = "has_feature_formulas_ai",
  SHOW_COMMERCE_MODAL = "show_commerce_modal",
}

export enum FLAGS_BY_USER_ENUM {
  IS_EXTERN_DEV = "is_extern_dev",
}
